module.exports = __webpack_public_path__ + "img/template1.17b6c21a.png";